import React from "react";
import InnerHeader from "./InnerHeader";
import TabsSec from "./TabsSec";
import ContactSec from "./ContactSec";
import { useParams } from "react-router-dom";

const OurSolutions = () => {
  const { solutionKey } = useParams();
  return (
    <div className="our-solutions-page">
      <InnerHeader
        heading="Our Solutions"
        desc="At Video Vision Media, we deliver solutions tailored to the industries we serve. From live sports to government communications, our expertise ensures content and connectivity are always reliable, always secure, and always ready for global audiences. "
      />
      <TabsSec solutionKey={solutionKey} />
      <section className="who-sec">
        <img src="/who-bg.png" alt="who-bg" className="who-bg" />
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-12">
              <h2 className="sec-head white">Who We Are</h2>
              <p className="para white">
                Video Vision Media is a next-generation media technology and
                satellite services company. We empower broadcasters, telecom
                operators, enterprises, and governments to connect, create, and
                deliver content seamlessly anytime, anywhere, on any platform.
                From our hubs in the UK, UAE, India and Singapore, we bring
                together satellite, cloud, and IP networks with creative
                post-production services, studio and playout services, giving
                our clients end-to-end solutions that are reliable, innovative,
                and scalable.
              </p>
            </div>
            <div className="col-lg-5 col-12">
              <img
                src="/who-we-are.png"
                alt="who-img"
                className="who-img w-100 h-auto"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="story-sec">
        <img src="/map.png" alt="story-bg" className="map-bg" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h2 className="sec-head white xsm has-red-bg">Our Story</h2>
              <p className="para mb-0">
                Founded in 1999 to bridge the gap between traditional satellite
                distribution and the rapidly evolving digital media landscape,
                Video Vision has grown into a trusted partner for some of the
                world’s most demanding industries.
              </p>
              <ul className="srv-dist-card-list like-para">
                <li>
                  We began with satellite TV distribution and teleport services,
                  building a reputation for uptime and reliability.
                </li>
                <li>
                  We added playout, enabling broadcasters and content owners to
                  manage, localize, and deliver programming seamlessly across
                  platforms.
                </li>
                <li>
                  We expanded into fiber/IP and cloud distribution, supporting
                  the rise of OTT, streaming, and remote production.
                </li>
                <li>
                  We are evolving further into IoT, enterprise connectivity, and
                  hybrid cloud solutions, helping organisations extend their
                  reach and resilience.
                </li>
              </ul>
              <h2 className="sec-head white xsm has-red-bg mt-5">Our Values</h2>
              <ul className="srv-dist-card-list like-para">
                <li>
                  <strong>Reliability &amp; Trust</strong> – Always-on services
                  backed by carrier-grade infrastructure.
                </li>
                <li>
                  <strong>Innovation &amp; Agility</strong> – Continuously
                  evolving to meet tomorrow’s media challenges.
                </li>
                <li>
                  <strong>Customer First</strong> – Tailored solutions designed
                  around different needs; not one-size-fits-all.
                </li>
                <li>
                  <strong>Global Reach, Local Support</strong> – Serving 100+
                  countries with dedicated teams in the UAE, UK, and worldwide
                  partnerships.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="who-sec">
        <img src="/global-bg.png" alt="who-bg" className="who-bg" />
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <h2 className="sec-head white">Our Global Presence</h2>
              <ul className="srv-dist-card-list like-para white">
                <li>
                  <strong>UAE</strong> – Media distribution, satellite teleport,
                  creative &amp; playout hub.
                </li>
                <li>
                  <strong>UK</strong> – Broadcast operations, media telecom
                  integration, and pan-European support.
                </li>
                <li>
                  <strong>Worldwide</strong> – Partner teleports, fiber/IP
                  nodes, and cloud integration across major regions.
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-12">
              <img
                src="/glob.png"
                alt="who-img"
                className="who-img w-100 h-auto"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="story-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h2 className="sec-head white xsm has-red-bg">
                Why Choose Video Vision
              </h2>
              <ul className="srv-dist-card-list like-para">
                <li>
                  End-to-End Capability – From creative to playout to global
                  distribution.
                </li>
                <li>
                  Cross-Industry Reach – Broadcast, sports, telecom, enterprise,
                  maritime/aviation, and government.
                </li>
                <li>
                  Proven Track Record – Delivering global sports coverage, cloud
                  migrations, enterprise IoT deployments, and national
                  broadcaster recovery solutions.
                </li>
                <li>
                  Future-Focused – Expanding into hybrid cloud, IoT, AI-driven
                  workflows, and LEO/MEO connectivity.
                </li>
              </ul>

              <h2 className="sec-head white xsm has-red-bg mt-5">
                Leadership &amp; Expertise
              </h2>
              <ul className="srv-dist-card-list like-para">
                <li>
                  Our leadership brings over a decade of experience across
                  broadcast engineering, satellite telecoms, and international
                  media rights management. Combined with a growing team of
                  creative, technical, and operations experts, we deliver the
                  clarity, resilience, and innovation our clients demand.
                </li>
              </ul>

              <h2 className="sec-head white xsm has-red-bg mt-5">
                Clients and Partnerships
              </h2>
              <p className="para mb-0">
                Our customers include broadcasters, OTT platforms, telecom
                operators, enterprises, and government agencies. We collaborate
                with global cloud and infrastructure providers to ensure the
                highest quality and performance.
              </p>
            </div>
          </div>
        </div>
      </section>
      <ContactSec />
    </div>
  );
};

export default OurSolutions;
